import { SideBar } from "js/editor/ui";
import renderReactRoot from "js/react/renderReactRoot";
import { RevisionPane } from "js/editor/dialogs/revisionPane";

const SlideRevisionsDialog = SideBar.extend({
    className: "editor_menu slide_revisions",
    type: "ShowSlideRevisionsDialog",
    lockSlide: true,

    initialize(options) {
        this.currentSlide = options.slide;
    },

    render() {
        this.unmountRevisionPane = renderReactRoot(RevisionPane, {
            currentSlide: this.currentSlide,
            onClose: () => this.close()
        }, this.el);
        return this;
    },

    remove(...args) {
        if (this.unmountRevisionPane) {
            this.unmountRevisionPane();
            this.unmountRevisionPane = null;
        }

        SideBar.prototype.remove.call(this, ...args);
    }

});

export { SlideRevisionsDialog };
